import { render, staticRenderFns } from "./BaseValidationEditTabRequirements.vue?vue&type=template&id=01f151fc&"
import script from "./BaseValidationEditTabRequirements.vue?vue&type=script&lang=js&"
export * from "./BaseValidationEditTabRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports